import SearchIcon from '@mui/icons-material/Search';
import { Avatar, Box, FormControlLabel, InputBase, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import {
  closeWorkAssignments,
  IJob,
  IWorkAssignment,
  IWorkAssignmentsDTOWrapper,
} from 'wisestep-api';
import { WsButton, WsDataTable, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import NoDataFoundCard from '../../../../../../components/noDataFoundCard';
import { failed, success } from '../../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../../utils/NotificationStore';

interface activeRecruitersProps {
  job: IJob;
  onRecruiterChange(): void;
}

const assignmentsObject: IWorkAssignmentsDTOWrapper = {
  assignedByRecruiterId: '',
  workAssignmentDTOList: [],
  recruiterDTOList: [],
  jobDTOList: [],
  teamDTOList: [],
  vendorPartnerDTOList: [],
};

const ActiveRecruiters = ({ job, onRecruiterChange }: activeRecruitersProps) => {
  const columns = [
    { Header: 'Recruiters', accessor: 'recruiters' },
    { Header: 'Action', accessor: 'action' },
  ];
  const tableData: Record<string, unknown>[] = [];
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [recruitersData, setRecruitersData] = useState<IWorkAssignment[]>();

  useEffect(() => {
    const acceptedRecruiters = job.assignedTo?.filter((recruiter) => {
      return recruiter.isAccepted == true;
    });

    setRecruitersData(acceptedRecruiters ?? []);
  }, [job]);

  recruitersData?.forEach((element) => {
    tableData.push({
      recruiters: (
        <FormControlLabel
          control={<Avatar />}
          label={
            <Box p={1}>
              {element.recruiterName && (
                <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                  {element.recruiterName}
                </WsTypography>
              )}
            </Box>
          }
        />
      ),
      action: (
        <WsButton variant="outlined" size="small" onClick={() => unAssignRecruiter(element)}>
          Unassign
        </WsButton>
      ),
    });
  });

  const unAssignRecruiter = async (recruiter: IWorkAssignment) => {
    const assignments = assignmentsObject;
    try {
      if (job.id && recruiter.recruiterId && job.assignedTo) {
        assignments.jobDTOList.push(job.id);
        assignments.recruiterDTOList.push(recruiter.recruiterId);
        await closeWorkAssignments(assignments);
        setNotification(success('Recruiter Is unassigned from the Job'));
        onRecruiterChange();
      }
    } catch (e) {
      setNotification(failed('Something went wrong, Please try again !!'));
    }
  };

  const onRecruitersInput = (event) => {
    if (!isEmpty(event.target.value)) {
      const filteredRows =
        job.assignedTo?.filter((row) => {
          return row?.recruiterName?.toLowerCase().includes(event.target.value.toLowerCase());
        }) ?? [];
      setRecruitersData(filteredRows);
    } else {
      setRecruitersData(recruitersData ?? []);
    }
  };

  return (
    <>
      {recruitersData && recruitersData?.length > 0 ? (
        <Box py={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <SearchIcon />
            <InputBase placeholder="search" onChange={onRecruitersInput} fullWidth />
          </Stack>
          <WsDataTable
            columns={columns}
            data={tableData}
            boldItems={['recruiters']}
            dense={false}
            headless={false}
          />
        </Box>
      ) : (
        <NoDataFoundCard text="No active recruiters found" />
      )}
    </>
  );
};

export default ActiveRecruiters;
